import { makeStyles } from '@mui/styles';
import _ from 'lodash';
import React, { useState } from 'react';

import { useTranslation } from '../../../../custom-hooks/useTranslation';
import DashboardDialog from '../DashboardDialog';

const useStyles = makeStyles({
  root: {
    width: '100%',
    minWidth: 360,
  },
});

const EmbeddedEdit = ({ part, tab, onAccept, onCancel }) => {
  const { graph } = tab;
  const [url, setUrl] = useState(graph.embeddedUrl);
  const [data, setData] = useState({ part, tab });
  const classes = useStyles();
  const translateString = useTranslation();

  function handleDataChange(updates) {
    const clonedData = JSON.parse(JSON.stringify(data));

    updates.forEach(({ path, value }) => {
      _.set(clonedData, path, value);
    });

    setData(clonedData);
  }

  function handleChangeUrl(e) {
    setUrl(e.target.value);
    handleDataChange([{ path: `tab.graph[${e.target.name}]`, value: e.target.value }]);
  }

  const cancelButton = {
    label: translateString('Cancel'),
    onClick: onCancel,
  };

  const acceptButton = {
    label: translateString('Accept'),
    onClick: () => onAccept(data),
  };

  return (
    <DashboardDialog
      data={data}
      buttonProps={[cancelButton, acceptButton]}
      onChange={handleDataChange}
      onClose={onCancel}
    >
      <div className={classes.root}>
        {translateString('Enter URL for the Embedded Content')}
        <input type="text" name="embeddedUrl" value={url} onChange={handleChangeUrl} />
      </div>
    </DashboardDialog>
  );
};

export default EmbeddedEdit;
